import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components for better performance
const StoreList = lazy(() => import('../Pages/StoreList'));
const StoreAdd = lazy(() => import('../Pages/StoreAdd'));
const StoreAddV2 = lazy(() => import('../Pages/StoreAddV2'));
const StoreEdit = lazy(() => import('../Pages/StoreEdit'));
const StoreEditV2 = lazy(() => import('../Pages/StoreEditV2'));
const StoreView = lazy(() => import('../Pages/StoreView'));
const StoreView2 = lazy(() => import('../Pages/StoreViewV2'));
const StoreOperatingHours = lazy(() => import('../Pages/StoreOperatingHours'));

/**
 * Store module routes
 * @param {Object} props - Component props
 * @returns {JSX.Element} - Store routes
 */
const StoreRoute = (props) => {
  const { history } = props;

  return (
    <>
      {/* Store List Route */}
      <Route
        exact
        path="/:lng/settings/stores"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <StoreList history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      {/* Store Add Route */}
      <Route
        exact
        path="/:lng/settings/stores/add"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <StoreAdd history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      {/* Store Add V2 Route */}
      <Route
        exact
        path="/:lng/settings/stores/add-v2"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <StoreAddV2 history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      {/* Store Edit Route */}
      <Route
        exact
        path="/:lng/settings/stores/edit/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <StoreEdit history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      {/* Store Edit V2 Route */}
      <Route
        exact
        path="/:lng/settings/stores/edit-v2/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <StoreEditV2 history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      {/* Store View Route */}
      <Route
        exact
        path="/:lng/settings/stores/view/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <StoreView history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />

      {/* <Route
        exact
        path="/:lng/settings/stores/view/:slack"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <StoreView2 history={history} />
            </Suspense>
          </React.Fragment>
        )}
      /> */}

      {/* Store Operating Hours Route */}
      <Route
        exact
        path="/:lng/settings/stores/operating-hours"
        render={() => (
          <React.Fragment>
            <Suspense fallback={<Loading />}>
              <StoreOperatingHours history={history} />
            </Suspense>
          </React.Fragment>
        )}
      />
    </>
  );
};
function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
export default StoreRoute;
